export default "__VITE_ASSET__9210944b__"